import { ItemPreviewsProvider, MiskatonicTraumaProvider } from './ItemPresentationContext';
import React from 'react';
import { GameState } from '../api';
import { useMonsterTokenStyle } from '../utils/clientSettings';
import { InvestigatorSheet, InvestigatorSheetProps } from './InvestigatorSheet';
import { InvestigatorDigitalSheet } from './InvestigatorDigitalSheet';
import { SpellCastingPreviewsProvider } from './SpellCastingContext';

export interface InvestigatorDisplayProps extends InvestigatorSheetProps {
  /** Compact reference content used by mobile Digital selection actions and wiki previews. */
  selectionPreview?: boolean;
  variant?: 'reference' | 'game';
  gameState?: GameState;
}

export const InvestigatorDisplay: React.FC<InvestigatorDisplayProps> = ({ variant = 'game', gameState, selectionPreview, ...props }) => {
  const artwork = useMonsterTokenStyle();
  return artwork === 'Classic' ? <InvestigatorSheet {...props} variant={variant} />
    : <MiskatonicTraumaProvider enabled={gameState ? !!gameState.gameSettings?.includeMiskatonicCards : undefined}><SpellCastingPreviewsProvider previews={variant === 'reference' ? {} : gameState?.spellCastingPreviews}><ItemPreviewsProvider previews={variant === 'reference' ? {} : gameState?.itemCardPreviews}><InvestigatorDigitalSheet {...props} selectionPreview={selectionPreview} variant={variant} gameState={gameState} /></ItemPreviewsProvider></SpellCastingPreviewsProvider></MiskatonicTraumaProvider>;
};
